import { z } from 'zod';
import { BILLING_INTERVALS, SUBSCRIPTION_STATUSES } from './enums.js';
import { IsoDateTime, MoneyCents } from './primitives.js';
/** The plan every member subscribes to in phase 1. The seed creates it. */
export const MEMBER_PLAN_CODE = 'MEMBER_MONTHLY';
/** New members get a 7 day free trial, card captured up front (D27). */
export const MEMBER_TRIAL_DAYS = 7;
/**
 * Statuses that give member access (domain.md, Subscription status). A
 * PAST_DUE grace period is O23, so PAST_DUE is not entitled until it is
 * decided. Trial members are entitled pending O27.
 */
export const ENTITLED_SUBSCRIPTION_STATUSES = [
    'TRIALING',
    'ACTIVE',
];
/** Statuses that block a new checkout. Backed by a partial unique index. */
export const LIVE_SUBSCRIPTION_STATUSES = [
    'PENDING',
    'TRIALING',
    'ACTIVE',
    'PAST_DUE',
];
export function isEntitledStatus(status) {
    return ENTITLED_SUBSCRIPTION_STATUSES.includes(status);
}
/** `GET /billing/subscription`: the member's current or most recent subscription. */
export const MemberSubscriptionDto = z.object({
    status: z.enum(SUBSCRIPTION_STATUSES),
    /** Whether member-only features are open right now. Screens use this, never the status. */
    entitled: z.boolean(),
    plan: z.object({
        name: z.string(),
        amountCents: MoneyCents,
        interval: z.enum(BILLING_INTERVALS),
    }),
    trialEndsAt: IsoDateTime.nullable(),
    currentPeriodStart: IsoDateTime.nullable(),
    currentPeriodEnd: IsoDateTime.nullable(),
    /** Set after a cancel: access continues until `accessEndsAt`, then the subscription ends. */
    cancelAtPeriodEnd: z.boolean(),
    cancelledAt: IsoDateTime.nullable(),
    /** When access ends if nothing changes: the trial end or the period end. Null while PENDING. */
    accessEndsAt: IsoDateTime.nullable(),
});
export const MemberSubscriptionResult = z.object({
    /** Null when the member has never started a checkout. */
    subscription: MemberSubscriptionDto.nullable(),
});
/**
 * `POST /billing/checkout`. The web app renders a hidden form with these
 * fields and submits it to `processUrl` (PayFast's hosted checkout).
 */
export const CheckoutDto = z.object({
    processUrl: z.url(),
    fields: z.record(z.string(), z.string()),
});
//# sourceMappingURL=billing.js.map